import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/**
 * Converts a date string to the format required by HTML datetime-local input.
 * Uses UTC mode to preserve the stored time without browser timezone conversion.
 *
 * @example
 * toDateTimeLocalValue('2025-12-30 14:00:00.000000 +00:00'); // "2025-12-30T14:00"
 * toDateTimeLocalValue(null); // ""
 */
export const toDateTimeLocalValue = (
  dateInput: string | null | undefined,
): string => {
  if (!dateInput) return '';
  const date = dayjs.utc(dateInput);
  if (!date.isValid()) return '';
  return date.format('YYYY-MM-DDTHH:mm');
};
